import { ModalDelete } from '../../../components/Modals/General/ModalDelete/ModalDelete'
import { Button } from '../../../components/Button/Button'
import { BreadCrumbs } from '../../../components/BreadCrumbs/breadCrumbrs'
import { useNavigate } from 'react-router-dom'
import useModals from '../../../hooks/useModals'
import { ModularDataTable } from '../../../components/ModularDataTable'
import { useEffect, useMemo, useState } from 'react'
import { createActions } from './factory/actionsFactory'
import { createColumns } from './factory/generateColumns'
import { useDinamicPages } from './factory/useDinamicPages'
import { i18n } from '../../../translate/i18n'

export const DinamicPage = () => {
    const navigate = useNavigate()
    const {
        aggregatorDinamicPage,
        tableLoading,
        pagination,
        sorting,
        handleDataChange,
        handlePaginationChange,
        handleSortingChange,
        setTableLoading,
        getAggregatorDinamicPage,
        deleteAggregatorDinamicPage,
        updateAggregatorDinamicPage
    } = useDinamicPages()
    const { showDeleteModal } = useModals()
    const [deleteId, setDeleteId] = useState<number>(0)

    async function switchStatus({ endpoint, Id, status }: { endpoint: string; Id: number; status: boolean }) {
        const findIndex = aggregatorDinamicPage.findIndex((item) => item.id === Id)
        if (findIndex !== -1) {
            const updatedData = [...aggregatorDinamicPage]
            updatedData[findIndex].status = status
            const newD: any = updatedData[findIndex]
            await updateAggregatorDinamicPage(Id, newD)
        }
    }

    const columns = useMemo(() => createColumns({ switchStatus: switchStatus }), [])

    const actions = useMemo(() => createActions({
        navigate,
        showDeleteModal,
        setDeleteId,
    }), [])


    async function loadPage() {
        setTableLoading(true)
        await getAggregatorDinamicPage()
        setTableLoading(false)
    }

    useEffect(() => {
        loadPage()
    }, [])

    return (
        <>
            <div className='row g-5 gx-xxl-12'>
                <div className='card card-xxl-stretch mb-5 mb-xl-12'>
                    <div className='card-header py-5 d-flex flex-column'>
                        <div className='d-flex justify-content-between'>
                            <h3 className='card-title align-items-start flex-column'>
                                <span className='card-label fw-bolder fs-3 mb-1'>{i18n.t(`agregador_dinamic_page.title`)}</span>
                                <BreadCrumbs />
                                <span className='text-muted mt-1 fw-bold fs-7'>
                                    {i18n.t(`agregador_dinamic_page.subTitle`)}
                                </span>
                            </h3>

                            <div className='card-toolbar'>
                                <Button
                                    text={i18n.t(`buttons.add`)}
                                    color='primary'
                                    iconColor='#FFF'
                                    icon='fas fa-plus'
                                    size='small'
                                    horizontalPadding={6}
                                    btnAttr={{
                                        type: 'button',
                                    }}
                                    click={() => navigate('create')}
                                    btnClass='mb-5 fw-bolder'
                                />
                            </div>
                        </div>


                    </div>
                    <div className='card-body'>
                        <ModularDataTable
                            data={aggregatorDinamicPage}
                            columns={columns}
                            actions={actions}
                            pagination={pagination}
                            onPaginationChange={handlePaginationChange}
                            sorting={sorting}
                            onSortingChange={handleSortingChange}
                            onDataChange={handleDataChange}
                            searchable={true}
                            searchPlaceholder='Pesquisar página...'
                            loading={tableLoading}
                            selectable={false}
                            striped={false}
                            hover={false}
                            size='md'
                            className='table-row-bordered table-row-gray-200'
                            alterColumns
                            persistPageKey='dinamic_page_agregador'
                            persistContextKey='default'
                        />
                    </div>
                </div>
            </div>

            <ModalDelete confirmAction={() => deleteAggregatorDinamicPage(deleteId)} text='delete_item' />
        </>
    )
}